<div *ngIf="pageIsReady$ | async" id="page-is-ready"></div>
<div *ngIf="stateIsLoading$ | async" id="state-is-loading"></div>
